<template>
  <div class="info-page">
    <Crumbs title="优质企业管理" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>企业信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="企业名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入企业名称"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="所属行业" prop="industryType">
              <enumerate
                v-model="form.industryType"
                url="/api/company/getindustryenum"
                placeholder="请选择所属行业"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在地区" prop="provinceCode">
              <enumerate
                v-model="form.provinceCode"
                url="/api/company/regionenum"
                placeholder="请选择所在地区"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="成立时间" prop="foudationDate">
              <el-date-picker
                v-model="form.foudationDate"
                type="date"
                placeholder="请选择成立时间"
                value-format="yyyy-MM-dd"
                prefix-icon="el-icon-date"
                style="width: 100%"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="官网链接" prop="linkUrl">
              <el-input
                v-model="form.linkUrl"
                placeholder="请输入官网链接"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="10"
          v-for="(item, index) in form.buWord"
          :key="'buWord' + index"
        >
          <el-col :span="8">
            <el-form-item
              :label="index === 0 ? '业务词条信息' : ''"
              :prop="`buWord[${index}]`"
              :rules="{ required: true, message: '请输入业务词条' }"
            >
              <el-input
                v-model="form.buWord[index]"
                placeholder="请输入业务词条"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <template v-if="index === form.buWord.length - 1">
              <el-button
                plain
                type="primary"
                icon="el-icon-plus"
                circle
                :disabled="buWordHasEmpty"
                @click.prevent="addItem(form.buWord, 4)"
              ></el-button>
            </template>
            <template v-else>
              <el-button
                plain
                type="warning"
                icon="el-icon-minus"
                circle
                @click.prevent="removeItem(form.buWord, index)"
              ></el-button>
            </template>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="企业简介" prop="description">
              <el-input
                v-model.trim="form.description"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入企业简介"
                maxlength="2000"
                resize="none"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="info-page__item" v-if="form.comFinList.length > 0">
        <div class="info-page__title">
          <span>融资信息</span>
        </div>
        <div v-for="(item, index) in form.comFinList" :key="index">
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item
                label="融资时间"
                :prop="'comFinList.' + index + '.roundDate'"
                :rules="{ required: true, message: '请选择融资时间' }"
              >
                <el-date-picker
                  v-model="item.roundDate"
                  type="date"
                  placeholder="请选择融资时间"
                  value-format="yyyy-MM-dd"
                  prefix-icon="el-icon-date"
                  style="width: 100%"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item
                label="轮次"
                :prop="'comFinList.' + index + '.round'"
                :rules="{ required: true, message: '请输入轮次' }"
              >
                <el-input
                  v-model="item.round"
                  placeholder="请输入轮次"
                  maxlength="20"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item
                label="金额"
                :prop="'comFinList.' + index + '.roundMoney'"
                :rules="{ required: true, message: '请输入金额' }"
              >
                <el-input-number
                  v-model="item.roundMoney"
                  controls-position="right"
                  :min="0"
                ></el-input-number>
                <span style="padding-left: 10px">万元</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item
                label="投资方"
                :prop="'comFinList.' + index + '.investor'"
                :rules="{ required: true, message: '请输入投资方' }"
              >
                <el-input
                  v-model="item.investor"
                  placeholder="请输入投资方"
                  maxlength="50"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-form-item>
              <el-button
                v-if="index === form.comFinList.length - 1"
                size="mini"
                type="primary"
                plain
                @click.prevent="addFina(index)"
                >继续添加</el-button
              >
              <el-button
                size="mini"
                type="danger"
                plain
                @click.prevent="removeFina(index)"
                >删除</el-button
              >
            </el-form-item>
          </el-row>
        </div>
      </div>
      <div class="info-page__item" v-if="form.buName.length > 0">
        <div class="info-page__title">
          <span>资质信息</span>
        </div>
        <div v-for="(item, index) in form.buName" :key="index">
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item
                label="资质名称"
                :prop="'buName.' + index + '.content'"
                :rules="{ required: true, message: '请输入资质名称' }"
              >
                <el-input
                  v-model="item.content"
                  placeholder="请输入资质名称"
                  maxlength="50"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item
                label="数量"
                :prop="'buName.' + index + '.zzCount'"
                :rules="{ required: true, message: '请输入数量' }"
              >
                <el-input-number
                  v-model="item.zzCount"
                  :min="0"
                  :step-strictly="true"
                  :precision="0"
                  controls-position="right"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-form-item>
              <el-button
                v-if="index === form.buName.length - 1"
                size="mini"
                type="primary"
                plain
                @click.prevent="addCert(index)"
                >继续添加</el-button
              >
              <el-button
                size="mini"
                type="danger"
                plain
                @click.prevent="removeCert(index)"
                >删除</el-button
              >
            </el-form-item>
          </el-row>
        </div>
      </div>
      <div class="info-page__item" v-if="form.comProList.length > 0">
        <div class="info-page__title">
          <span>产品信息</span>
        </div>
        <div v-for="(item, index) in form.comProList" :key="index">
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item
                label="产品名称"
                :prop="'comProList.' + index + '.name'"
                :rules="{ required: true, message: '请输入产品名称' }"
              >
                <el-input
                  v-model="item.name"
                  placeholder="请输入产品名称"
                  maxlength="50"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item
                label="产品图片"
                :prop="'comProList.' + index + '.imgList'"
                :rules="{ required: true, message: '请上传产品图片' }"
              >
                <image-upload
                  url="/api/expert/uploadreqimfile"
                  accept="image/jpeg,image/png,image/bmp"
                  :file-list.sync="item.imgList"
                  :multiple="false"
                  :num-limit="1"
                  :size-limit="10"
                >
                  <template>
                    <el-alert
                      :title="`上传图片格式要求 jpg、jpeg、bmp、png；每个大小不超过10MB；图片名(包含后缀名)的最大长度为100个字符。`"
                      type="warning"
                    >
                    </el-alert>
                  </template>
                </image-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="16">
              <el-form-item
                label="产品简介"
                :prop="'comProList.' + index + '.description'"
                :rules="{ required: true, message: '请输入产品简介' }"
              >
                <el-input
                  type="textarea"
                  v-model="item.description"
                  placeholder="请输入产品简介"
                  :autosize="{ minRows: 3 }"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-form-item>
              <el-button
                v-if="index === form.comProList.length - 1"
                size="mini"
                type="primary"
                plain
                @click.prevent="addProd(index)"
                >继续添加</el-button
              >
              <el-button
                size="mini"
                type="danger"
                plain
                @click.prevent="removeProd(index)"
                >删除</el-button
              >
            </el-form-item>
          </el-row>
        </div>
      </div>
      <div class="info-page__operation">
        <el-row :gutter="10">
          <el-form-item>
            <el-button type="text" icon="el-icon-plus" @click.prevent="addFina"
              >融资信息</el-button
            >
            <el-button type="text" icon="el-icon-plus" @click.prevent="addCert"
              >资质信息</el-button
            >
            <el-button type="text" icon="el-icon-plus" @click.prevent="addProd"
              >产品信息</el-button
            >
          </el-form-item>
        </el-row>
      </div>
    </el-form>
    <div class="submit fn-text-center mt-20">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
import CheckObj from "@/utils/check.js";
export default {
  name: "companyInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        name: "",
        industryType: "", // integer
        provinceCode: "", // integer
        foudationDate: "",
        linkUrl: "",
        buWord: [""],
        description: "",
        //融资
        comFinList: [],
        //资质
        buName: [],
        //产品
        comProList: [] // 对应处理后的 comProModel
      },
      rules: {
        name: [isEmpty("请输入企业名称")],
        industryType: [isEmpty("请选择所属行业", "change")],
        provinceCode: [isEmpty("请选择所在地区", "change")],
        foudationDate: [isEmpty("请选择成立时间")],
        linkUrl: [
          {
            validator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (value && !CheckObj.checkURL(value)) {
                  reject(new Error("请输入正确的网址"));
                } else {
                  resolve();
                }
              });
            },
            trigger: "blur"
          }
        ],
        description: [isEmpty("请输入企业简介")]
      }
    };
  },
  computed: {
    // 业务词条 是否有空项目
    buWordHasEmpty() {
      return this.form.buWord.some((item) => {
        return item === "";
      });
    }
  },
  created() {
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    // 业务词条 添加删除一项
    addItem(list, limit) {
      if (limit && list.length >= limit) return;
      list.push("");
    },
    removeItem(list, index) {
      list.splice(index, 1);
    },
    // 添加删除融资
    addFina() {
      // if (this.form.comFinList.length > 10) return;
      this.form.comFinList.push({
        round: "",
        roundDate: "",
        roundMoney: "0",
        investor: ""
      });
    },
    removeFina(index) {
      this.form.comFinList.splice(index, 1);
    },
    // 添加删除资质
    addCert() {
      // if (this.form.buName.length > 10) return;
      this.form.buName.push({
        content: "",
        zzCount: 0
      });
    },
    removeCert(index) {
      this.form.buName.splice(index, 1);
    },
    // 添加删除产品
    addProd() {
      // if (this.form.comProList.length > 10) return;
      this.form.comProList.push({
        name: "",
        imgList: [],
        description: ""
      });
    },
    removeProd(index) {
      this.form.comProList.splice(index, 1);
    },

    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // integer
        industryType,
        provinceCode,
        // list
        buWord,
        comProList,
        ...others
      } = this.form;
      // 处理字符串 转为数字
      const turnNumber = {
        industryType,
        provinceCode
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === "" ? -1 : turnNumber[key];
      });
      // 处理 comProModel
      const comProModel = comProList.map((item) => {
        const { imgList, ...rest } = item;
        // 处理上传文件
        const deconstruct = (file = {}) => {
          return file.response ? file.response.dataList[0].url : file.url || "";
        };
        const imgUrl = deconstruct(imgList[0]);
        return {
          ...rest,
          imgUrl
        };
      });
      return {
        ...others,
        ...turnNumber,
        comProModel,
        buWord: buWord.filter((item) => {
          return item !== "";
        })
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        // -1 => ""
        industryType,
        provinceCode,
        // list
        comProModel,
        ...others
      } = data;
      // 处理数字 转为字符串
      const turnNumber = {
        industryType,
        provinceCode
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === -1 ? "" : turnNumber[key];
      });
      // 处理 comProModel
      const comProList = comProModel.map((item) => {
        const { imgUrl, ...rest } = item;
        const imgList =
          imgUrl === ""
            ? []
            : [
                {
                  url: imgUrl
                }
              ];
        return {
          ...rest,
          imgList
        };
      });
      return {
        ...others,
        ...turnNumber,
        comProList
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },

    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("mentor", "addCompany", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("mentor", "modifyCompany", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },

    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("mentor", "getCompanyInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      this.redirectByPath(`/admin/mentorManage/companyList`);
    }
  }
};
</script>

<style lang="less" scoped></style>
